import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=99c2a72a&scoped=true"
import script from "./Divider.ts?vue&type=script&lang=ts&external"
export * from "./Divider.ts?vue&type=script&lang=ts&external"
import style0 from "./Divider.vue?vue&type=style&index=0&id=99c2a72a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c2a72a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99c2a72a')) {
      api.createRecord('99c2a72a', component.options)
    } else {
      api.reload('99c2a72a', component.options)
    }
    module.hot.accept("./Divider.vue?vue&type=template&id=99c2a72a&scoped=true", function () {
      api.rerender('99c2a72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Forms/components/Divider/Divider.vue"
export default component.exports